import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useBasketInfoSection} from '../hooks/useGetBasketPageSection';
import {BasketInfoSkeleton} from './BasketInfo.skeleton';
import {BasketInfoView} from './BasketInfoView';

import {InfoSection_Info_PlacementOption} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/page/basket_sections.types';
import {IconSize} from '@aboutyou/ui-components';

export const BasketInfo = (props: {
  placementFilter: InfoSection_Info_PlacementOption;
  iconSize?: keyof typeof IconSize;
}) => {
  return (
    <DataFetcher
      request={useBasketInfoSection()}
      Error={() => null}
      View={BasketInfoView}
      Loading={BasketInfoSkeleton}
      viewProps={props}
    />
  );
};
